<template>
	<div
		v-if="context.kontaktpersonen.length"
		role="region"
		aria-label="Kontaktpersonen"
	>
		<nk-wrapper
			v-for="(kontaktpersonen, kontaktpersonenIndex) in sortedKontaktpersonen"
			:key="`kontaktpersonen-${kontaktpersonenIndex}`"
			spacing="sm"
		>
			<nk-accordion
				:title="kontaktpersonen.letter"
				title-size="lg"
				:open="openAccordion(kontaktpersonenIndex)"
			>
				<nk-row vertical-gutter="2" gutter="2">
					<nk-col
						v-for="(mitarbeiter, mitarbeiterIndex) in kontaktpersonen.children"
						:key="`mitarbeiter-${mitarbeiterIndex}`"
						cols="full"
						lg="6/12"
						xl="4/12"
					>
						<nk-card variant="boxed" :grouped="false">
							<template #header>
								<nk-link
									block
									:link="`${
										context.taggingpfad.slice(-1) !== '/'
											? context.taggingpfad + '/'
											: context.taggingpfad
									}${
										$slugify(mitarbeiter.vorname + '-' + mitarbeiter.nachname) +
										'-id_' +
										mitarbeiter.id
									}`"
								>
									<nk-title tag="h3" size="md" no-margin>
										{{ mitarbeiter.vorname }}
										{{ mitarbeiter.nachname }}
									</nk-title>
								</nk-link>
								<div v-html="mitarbeiter.funktion" />
							</template>
							<template #body>
								<nk-address
									variant="vertical"
									:email="
										mitarbeiter.kommunikationsmoeglichkeiten &&
										mitarbeiter.kommunikationsmoeglichkeiten.find(
											kontaktArt => kontaktArt.kanal === 'EMAIL',
										)
											? mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'EMAIL',
												).kennung
											: null
									"
									:telefonnummern="
										mitarbeiter.kommunikationsmoeglichkeiten
											.filter(kontaktArt => kontaktArt.kanal === 'TELEFON')
											.map(telefon => {
												return {
													telefon: telefon.kennung,
													zusatz: telefon.kennungszusatz,
												};
											})
									"
									:mobil="
										mitarbeiter.kommunikationsmoeglichkeiten &&
										mitarbeiter.kommunikationsmoeglichkeiten.find(
											kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
										)
											? mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
												).kennung
											: null
									"
								/>
							</template>
						</nk-card>
					</nk-col>
				</nk-row>
			</nk-accordion>
		</nk-wrapper>
	</div>
</template>

<script>
import {groupBy} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {array} context.kontaktpersonen
 * @prop {string} context.taggingpfad
 * @prop {boolean} options.openAccordion
 * @prop {number} options.openAccordionIndex
 */
export default {
	name: 'NkTemplateServiceBwKontaktpersonen',

	mixins: [TemplatesDefault],

	computed: {
		sortedKontaktpersonen() {
			const sortedAndGrouped = groupBy(
				[...this.context.kontaktpersonen].sort((a, b) => {
					const nameA = (a.familienname || a.nachname).toUpperCase();
					const nameB = (b.familienname || b.nachname).toUpperCase();
					return nameA.localeCompare(nameB);
				}),
				person => {
					const name = (person.familienname || person.nachname).toUpperCase();
					return name.charAt(0);
				},
			);

			return Object.keys(sortedAndGrouped).map(letter => ({
				letter,
				children: sortedAndGrouped[letter],
			}));
		},
	},

	methods: {
		openAccordion(index) {
			if (this.options && typeof this.options.openAccordion !== 'undefined') {
				if (typeof this.options.openAccordion === 'boolean') {
					return this.options.openAccordion;
				}

				if (Number.isInteger(this.options.openAccordion)) {
					return this.options.openAccordion === index;
				}
			}
			return this.context.length === 1;
		},
	},
};
</script>

<style scoped>
.more-numbers-label {
  margin-right: 0.5rem;
}

.more-numbers {
  display: inline-block !important;
}
.more-numbers * {
  display: inline-block !important;
}
.more-numbers br {
  display: none;
}
</style>
